import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import InputForm from '../../../partials/inputForm'
import { styles } from './styles';


class AddMenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuId: this.props.menuId || "",
        }
        this.getData = this.getData.bind(this)
    }
    componentDidMount() {
        this.props.onRef(this);
        this.props.getList()
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.menuId !== this.props.menuId) {
            this.setState({ menuId: nextProps.menuId })
        }
    }
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    }
    getData() {
        return this.state.menuId
    }
    reset() {
        this.setState({ menuId: "" })
    }
    getLabel = (code) => {
        let {listMenuGroup = []} = this.props;
        let name = listMenuGroup.find((menu) => {
            return (code === menu.id)
        })
        return name ? name.name : ""
    }
    handleDelete = () => {
        this.setState({ menuId: "" })
    }
    queueList = (data = {}) => {
        let list = []
        if(data.subMenu && data.subMenu.fulfillmentValue && data.subMenu.fulfillmentValue.length) {
            data.subMenu.fulfillmentValue.forEach(e => {
                list = list.concat([e.id]);
                if(e.subMenu && e.subMenu.fulfillmentValue && e.subMenu.fulfillmentValue.length) {
                    list = list.concat(this.queueList(e.subMenu.fulfillmentValue))
                }
            })
        }
        return list
    }
    getList = () => {
        const {listMenuGroup = [], id, menuId, data = {}, listMultiLevel = []} = this.props;
        let list = [];
        list = listMenuGroup.filter(e => String(e.id) !== String(id) && String(e.parentCode) !== String(id));
        const ids = this.queueList(data);
        if(ids && ids.length) {
            list = list.filter(e => !ids.find(id => id === e.id))
        }
        return list;
    }
    render() {
        let { classes, t, isMenu  = false, disabled = false, data } = this.props;
        const {menuId} = this.state;
        return (
            <InputForm
                fullWidth={true}
                label={t('menu_menuitem_addmenuitem_group')}
                value={menuId}
                name="menuId"
                select 
                disabled={disabled}
                onChange={this.handleChange}
            >
                <MenuItem key={""} value={""}>{t('pls_select')}</MenuItem>
                {(this.getList() || []).map(row => {
                    return (
                        <MenuItem key={row.id} value={row.id}>{row.name}
                        </MenuItem>
                    )
                })}

            </InputForm>
        )
    }
}

AddMenuItem.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
AddMenuItem.defaultProps = {
    isMulti: true
}
const mapState = state => ({
    listMenuGroup: state.serviceMenu.listMenuGroup,
    listMultiLevel: state.serviceMenu.listMultiLevel,
});

const mapDispatch = dispatch => ({
    getList: dispatch.serviceMenu.getAllMenuGroup
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(AddMenuItem)));








